module.exports = __webpack_public_path__ + "static/media/FAQ.8a6e27dc.svg";